import { Typography } from "@mui/material"
import { translate } from "app/language/service"
import { getItemsByDay, getScheduleHoursText } from "form/tools/schedule"
import React from "react"
import { ICampaignScheduleFormItem } from "schedule/model"
import { FlexBox } from "ui/components/FlexBox"

interface ICampaignScheduleSummaryProps {
  items: ICampaignScheduleFormItem[]
  noSchedule: boolean
}

export const CampaignScheduleSummary = React.memo(({ items, noSchedule }: ICampaignScheduleSummaryProps) => {
  if (noSchedule) {
    return (
      <Typography id="summary-schedule-no-schedule" color="textPrimary" fontSize=".8rem" sx={{ ml: "1rem" }}>
        {translate("label.no.schedule")}
      </Typography>
    )
  }
  if (!items || items.length === 0) {
    return (
      <Typography id="summary-schedule-empty" color="textPrimary" fontSize=".8rem" sx={{ ml: "1rem" }}>
        {translate("label.schedule.empty")}
      </Typography>
    )
  }
  return (
    <>
      {getItemsByDay(items).map((group, indexGroup) => (
        <FlexBox
          id={`summary-schedule-group-${indexGroup}`}
          ai="start"
          jc="start"
          className="week-summary"
          key={group.day}>
          <Typography
            id={`summary-schedule-group-${indexGroup}-text`}
            color="textPrimary"
            fontSize=".85rem"
            sx={{ minWidth: "6rem", p: ".5rem", pl: "1rem", pr: 0 }}>
            {translate(`label.day.${group.day}`)}
          </Typography>
          <FlexBox
            vertical
            ai="start"
            jc="start"
            sx={{
              minWidth: "9rem",
              p: ".5rem",
              pl: 0,
              pr: "1rem"
            }}>
            {group.items.map((item, indexItem) => (
              <Typography
                id={`summary-schedule-group-value-${indexGroup}-${indexItem}`}
                key={indexItem}
                color="textPrimary"
                fontSize=".85rem"
                fontFamily="arial">
                {getScheduleHoursText(item.start, item.end)}
              </Typography>
            ))}
          </FlexBox>
        </FlexBox>
      ))}
    </>
  )
})
